/**
 * Titolo con tag HTML dinamico (h1..h6) — usato dai blocchi che competono
 * per il titolo principale di pagina (vedi `headingField` in registry.js e
 * il calcolo di `headingLevel` in BlockRenderer.jsx). Non cambia mai stile:
 * la classe CSS resta quella del blocco, cambia solo la semantica del tag.
 */
export function Heading({ level = 2, className, children }) {
  const Tag = `h${Math.min(Math.max(level, 1), 6)}`;
  return <Tag className={className}>{children}</Tag>;
}
